<section class="block-themes bg-primary section-inset-y">
  <main class="container text-center">
    <header class="mb-4">
      <span class="text-secondary fw-bold" *ngIf="block.subtitle">{{ block.subtitle }}</span>
      <h2 class="text-light" *ngIf="block.title">{{ block.title }}</h2>
    </header>
    <ul class="themes-list" *ngIf="themes.length">
      <a
        *ngFor="let theme of themes"
        [routerLink]="['/thema', theme.slug]"
        class="text-decoration-none themes-list__link"
        [routerLinkActive]="'d-none'"
      >
        <li class="themes-list__item">
          <span class="chip chip--primary chip--xl"><fstr-icon [anchor]="theme.icon" class="icon-lg"></fstr-icon></span>
          <span *ngIf="theme.title" class="text-primary fw-bold z-1">{{ theme.title }}</span>
        </li>
      </a>
    </ul>
  </main>
</section>
